import _ from 'lodash';
import Promise from 'bluebird';
import viasportBackend from '../service/viasportBackend';

export default function viasport({ config = {}, excludeParams, search, limit, offset, country, path, routeParams, language }) {
  if (config.method === 'slug' || config.method === 'related') {
    if (routeParams.slug === undefined) throw new Error(`method ${config.method} needs slug`);
    //if (routeParams.id === undefined) throw new Error(`method ${config.method} needs id`);
  }

  let excludedInResponse;
  if (config.lightResponse) {
    excludedInResponse = [
      'data.text.body',
      'data.preamble',
      'embedded.relatedArticles',
      'embedded.authors',
      'data.tags.participants',
    ];
  }

  switch (config.method) {
  case 'multi-tags':
    return Promise.all(_.map(config.tags, (tags) => {
      return viasportBackend.getContentContainers(tags, { q: true }, config.sort, config.limit, 0, country, excludeParams);
    }));
  case 'manual':
    return viasportBackend.getManualList(config.manualList, limit, country);
  case 'slug':
	  //console.log(`caseslug:  ` + JSON.stringify(routeParams));
    return viasportBackend.getContentContainer(routeParams.slug, country, search).then((result) => [result]);
  case 'related':
	  //console.log(`caserelated:  ` + JSON.stringify(routeParams));
    return viasportBackend.getRelatedContentContainers(routeParams.slug, config.relatedTagName, config.sort, limit, offset, country, excludeParams);
  case 'tags':
    const routeparams = config.ignoreParams ? _.omit(routeParams, config.ignoreParams) : routeParams;
    return viasportBackend.getContentContainers(config.configTagsOnly ? {} : routeparams, config.tags, config.sort, limit, offset, country, excludeParams, excludedInResponse);
  case 'tags_live':
	  //const routeparams = config.ignoreParams ? _.omit(routeParams, config.ignoreParams) : routeParams;
	  	//console.log(`case_tags_live:  ` + JSON.stringify(routeParams));
	    //okreturn viasportBackend.getContentContainers_live(config.tags, config.sort, limit, offset, country);
	    //routeparams = config.ignoreParams ? _.omit(routeParams, config.ignoreParams) : routeParams;
	    //return viasportBackend.getContentContainers_live(config.configTagsOnly ? {} : routeparams, config.tags, config.sort, limit, offset, country, excludeParams, excludedInResponse);
  case 'tags-with-extended-events':
    return viasportBackend.getContentContainersWithExtendedEvents(routeParams, config.tags, config.sort, limit, offset, country, excludeParams, excludedInResponse, language);
  case 'text':
    return viasportBackend.getTextPageContent(path.replace(/\//g, ''), country);
  case 'search':
    return viasportBackend.getSearchResults(search, limit, offset, country);
  case 'embed':
    return viasportBackend.getContentContainerById(routeParams, country);
  case 'selected-templates':
    return viasportBackend.getSelectedTemplates();
  default:
    throw new Error('No backend endpoint found for viasport config:', config);
  }
}



// WEBPACK FOOTER //
// ./src/provider/viasport.js